
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Lead, ProjectsPool, Task, User,
} from '@/types';

@Component
export default class EditLeadOpNumberDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly task: Task | undefined;

  dialog = false
  valid = false
  loading = false

  opTypes = [
    {
      text: '110%',
      value: '110',
    },
    {
      text: 'STD/50%',
      value: '50',
    },
  ]

  opNumber: string | null = null
  opType: string | null = null

  @Watch('value')
  async onValueChange(val: boolean) {
    if (val === true) {
      this.opNumber = this.selectedLead?.opNumber ?? null;
      this.opType = this.selectedLead?.opType ?? null;
    }
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get selectedLead(): Lead | null {
    const childLeads: ProjectsPool = this.$store.getters.currentChildren;

    // Se è stato specificato un Task e questo è associato ad una Lead figlia...
    if (this.task && this.task.relationship === 'father') {
      // ... se la lead figlia non è stata ancora assegnata,
      // non ritorna nulla.
      if ('childLeadId' in this.task === false || !this.task.childLeadId) return null;

      // ... se la lead figlia è stata assegnata,
      // considera i suoi dati.
      return childLeads[this.task.childLeadId];
    }

    // Negli altri casi ritorna la Lead selezionata memorizzata tramite Vuex
    return this.$store.getters.currentLead;
  }

  get userPermissions() {
    return this.$store.getters.currentUserPermissions;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  onCancel() {
    this.dialog = false;
  }

  async onUpdate() {
    this.loading = true;

    const update = {} as { [key: string]: unknown };

    update.opNumber = this.opNumber ?? null;
    update.opType = this.opType ?? null;

    this.$store.dispatch('updateTaskFields', update);

    await this.$store.dispatch('updateSelectedTask');

    this.dialog = false;

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
